import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, Typography } from "antd";
import { Link } from "react-router-dom";
import { PhoneInput } from "@/shared/components/PhoneInput";
import { useRegister } from "../hooks/useAuth";
import type { RegisterRequest } from "../types";

const { Title, Text } = Typography;

export function RegisterForm() {
	const [form] = Form.useForm<RegisterRequest>();
	const { mutate: register, isPending } = useRegister();

	const onFinish = (values: RegisterRequest) => {
		register(values);
	};

	return (
		<Card className="w-full max-w-md shadow-lg">
			<div className="text-center mb-8">
				<Title level={2} className="mb-2!">
					M Smart
				</Title>
				<Text type="secondary">Yangi hisob yaratish</Text>
			</div>

			<Form
				form={form}
				name="register"
				onFinish={onFinish}
				layout="vertical"
				requiredMark={false}
				size="large"
			>
				<Form.Item
					name="fullname"
					label="To'liq ism"
					rules={[
						{
							required: true,
							message: "Ismingizni kiriting",
						},
						{
							min: 2,
							message: "Ism kamida 2 ta belgidan iborat bo'lishi kerak",
						},
					]}
				>
					<Input
						prefix={<UserOutlined className="text-gray-400" />}
						placeholder="Abdullayev Sardor"
						autoComplete="name"
						id="register-fullname"
					/>
				</Form.Item>

				<Form.Item
					name="phone"
					label="Telefon raqam"
					rules={[
						{
							required: true,
							message: "Telefon raqamingizni kiriting",
						},
						{
							pattern: /^\+998\d{9}$/,
							message: "To'liq 9 ta raqam kiriting",
						},
					]}
				>
					<PhoneInput id="register-phone" size="large" />
				</Form.Item>

				<Form.Item
					name="password"
					label="Parol"
					rules={[
						{
							required: true,
							message: "Parolingizni kiriting",
						},
						{
							min: 4,
							message: "Parol kamida 4 ta belgidan iborat bo'lishi kerak",
						},
					]}
				>
					<Input.Password
						prefix={<LockOutlined className="text-gray-400" />}
						placeholder="Parol"
						autoComplete="new-password"
						id="register-password"
					/>
				</Form.Item>

				<Form.Item className="mb-0!">
					<Button type="primary" htmlType="submit" loading={isPending} block id="register-submit">
						Ro'yxatdan o'tish
					</Button>
				</Form.Item>
			</Form>

			<div className="text-center mt-4">
				<Text type="secondary">
					Hisobingiz bormi?{" "}
					<Link to="/login" className="text-blue-600 hover:text-blue-800">
						Kirish
					</Link>
				</Text>
			</div>
		</Card>
	);
}
